export default class Dashboard {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    getFeedAndPlugins() {
        return this.rest.one('dashboard').one('feed').get();
    };
    
    statisticsByAccountAndType(statisticTypeName) {
        return this.rest.one('dashboard').one('accountStatisticsByType', statisticTypeName).get();
    };
};

